export default function padLeft(str, length, padding) {
    let output = str;
    while (output.length < length) {
        output = padding + output;
    }
    return output;
}
